import axios from 'axios';
import {clearAlerts, setAlert} from './alert';
import {
    ADD_SUPPLIER_TRANSACTION,
    CLEAR_ERRORS,
    GET_SUPPLIER_TRANSACTION,
    GET_SUPPLIER_TRANSACTION_SUPPLIERS_DATA,
    GET_SUPPLIER_TRANSACTIONS, GET_SUPPLIERS_TRANSACTIONS,
    REMOVE_DELETE_SUPPLIER_TRANSACTION,
    REMOVE_UPDATE_SUPPLIER_TRANSACTION, REMOVE_UPDATE_SUPPLIER_TRANSACTION_FOR_SUPPLIER,
    SET_DELETE_SUPPLIER_TRANSACTION_ID, SET_LOADING, SET_UPDATE_SUPPLIER_TRANSACTION_FOR_SUPPLIER_ID,
    SET_UPDATE_SUPPLIER_TRANSACTION_ID, SUPPLIER_ERROR,
    SUPPLIER_TRANSACTION_ERROR, UNSET_LOADING, UPDATE_TRANSACTION_ERROR
} from './types';
import {request} from "../utils/service";

export const setLoading = () => (dispatch) => {
    dispatch({
        type: SET_LOADING,
    });
};
export const unsetLoading = () => (dispatch) => {
    dispatch({
        type: UNSET_LOADING,
    });
};

// getRowData after update in table
export const getSuppliersTransactions = (page = 1, filters = {}) => async (dispatch) => {
    dispatch(setLoading());
    dispatch(clearAlerts());
    let queryParams = '';
    if (filters) {
        Object.keys(filters).map((key, index) => queryParams += `&${key}=${filters[key]}`);
    }

    const res = await request(`/supplier-transactions/?page=${page}${queryParams}`, {method: 'GET'}, dispatch);


    if (res.hasOwnProperty('errors')) {
        const err = res.errors;
        dispatch(setAlert(err.response.statusText, 'danger'));
        dispatch(unsetLoading());
    } else {
        dispatch({
            type: GET_SUPPLIERS_TRANSACTIONS,
            payload: res
        });
    }
};

export const updateTransaction = (transaction, filters = {}) => async (dispatch) => {


    dispatch(clearAlerts());
    dispatch(setLoading());

    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    try {
        const res = await axios.put(`/supplier-transactions/${transaction.id}`, JSON.stringify(transaction), config);

        dispatch(setAlert("Transaksiya tahrirlandi!", 'success'));

        return true;
    } catch (err) {
        dispatch(unsetLoading());
        dispatch(setAlert(err?.response?.data?.message, 'danger'));
        return false;
    }
};


// getRowData after update in table
export const getSupplierTransactions = (supplier_id, filters = {}) => async (dispatch) => {

    let queryParams = '';
    if (filters) {
        Object.keys(filters).map((key, index) => queryParams += `&${key}=${filters[key]}`);
    }


    const res = await request(`/single-supplier-transactions/${supplier_id}?${queryParams}`, {method: 'GET'}, dispatch);


    if (res && res.hasOwnProperty('errors')) {
        const err = res.errors;
        dispatch(setAlert(err.response.statusText, 'danger'));
        dispatch({
            type: SUPPLIER_ERROR,
            payload: err,
        });
    } else {
        dispatch({
            type: GET_SUPPLIER_TRANSACTIONS,
            payload: res
        });
        dispatch(unsetLoading());
    }
};


export const addOrUpdateSupplierTransaction = (formData, filters = {}) => async (dispatch) => {
    dispatch(clearAlerts());
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };
    try {
        const res = await axios.put('/add-or-update-supplier-transaction/', formData, config);
        dispatch(setAlert('Tranzaksiya amalga oshirildi!', 'success'));
        dispatch(getSupplierTransactions(formData.supplier_id, filters));
        return true;
    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message, 'danger'));

        if (err?.response?.data?.errors) {
            dispatch({
                type: SUPPLIER_TRANSACTION_ERROR,
                payload: err.response.data,
            });
        } else {
            dispatch(setAlert("Yetkazuvchi balansiga tranzaksiya amalga oshirilmadi!", 'danger'));
        }
    }
};


// download report
export const downloadSupplierReport = (filters = {}) => async (dispatch) => {
    filters.object = 'supplier';
    dispatch(setLoading());
    dispatch(clearAlerts());
    let queryParams = '?';
    if (filters) {
        Object.keys(filters).map((key, index) => index == 0 ? queryParams += `${key}=${filters[key]}` : queryParams += `&${key}=${filters[key]}`);
    }
    const res = await request(`/reports/${queryParams}`, {method: 'GET'}, dispatch);
    if (res?.hasOwnProperty('errors')) {
        const err = res.errors;
        dispatch(setAlert(err.response.statusText, 'danger'));
        dispatch(unsetLoading());
        return false;
    } else {
        dispatch(unsetLoading());
        return res?.link;
    }
};


export const clearErrors = () => async (dispatch) => {
    dispatch({
        type: CLEAR_ERRORS,
    });
};







